import styled from 'styled-components';

export const ComparePlansStyled = styled.div`
  .Polaris-IndexTable-ScrollContainer {
    border: 1px solid #e0e0e0;
    border-radius: 12px;
  }
  .Polaris-IndexTable__ScrollBarContainer {
    display: none;
  }
  thead tr th {
    background-color: white;
  }
`;
